type Breakpoint = {
  minWidth?: number;
  maxWidth?: number;
  content: number;
  gutter?: number;
};

interface Breakpoints {
  [key: string]: Breakpoint;
}

type MediaQueryType = {
  up?: string;
  down?: string;
  only: string;
};

interface MediaQueriesInterface {
  [key: string]: MediaQueryType;
}

const breakpoints: Breakpoints = {
  xsMobile: {
    maxWidth: 375,
    content: 375,
    gutter: 12,
  },
  mobile: {
    minWidth: 376,
    maxWidth: 767,
    content: 364,
    gutter: 6,
  },
  tablet: {
    minWidth: 768,
    maxWidth: 1223,
    content: 740,
    gutter: 6,
  },
  desktop: {
    minWidth: 1224,
    content: 1212,
    gutter: 6,
  },
};

const mediaQueries = (breakpoints: Breakpoints): MediaQueriesInterface => {
  const media: Record<string, MediaQueryType> = {};
  const breakpoinstsArray = Object.entries(breakpoints);

  breakpoinstsArray.forEach(([key, { minWidth, maxWidth }], index) => {
    const mediaSettings: Record<string, string> = (media[key] = {only: ''});
    const nextBreakpoint = breakpoinstsArray[index + 1];

    if (minWidth) {
      mediaSettings['up'] = `@media screen and (min-width: ${minWidth}px)`;
    }

    if (maxWidth) {
      mediaSettings['down'] = `@media screen and (max-width: ${maxWidth}px)`;
    }

    if (index === 0) {
      mediaSettings['only'] = `@media screen and (max-width: ${maxWidth}px)`;
    } else if (nextBreakpoint) {
      mediaSettings['only'] = `@media screen and (min-width: ${minWidth}px) and (max-width: ${maxWidth}px)`;
    } else {
      mediaSettings['only'] = `@media screen and (min-width: ${minWidth}px)`;
    }
  });

  return media;
};

export default mediaQueries(breakpoints);
